import apiClient from "../../../network/apiClient";

export const addContentAPI = (params) => apiClient.post(`/webContent/insert?type=${params.type}`, params.body)
export const fetchWebContentAPI = () => apiClient.get("/webContent/getAll", { handle404Silently: true })
export const fetchWebContentByTypeAPI = ( type ) => apiClient.get(`/webContent/findByType?type=${type}`, { handle404Silently: true })
